import { queryFor } from "@visioni/a3s-client-api/app";
import { accessManagementEndpoint, usersSearchEndpoint } from "../client-messages/role-assignments";

export const accessManagementQuery = queryFor(accessManagementEndpoint);
export const usersSearchQuery = queryFor(usersSearchEndpoint);
